import React from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { stripeNonSecretKey } from 'Consts/keys';
import PaymentPageContent from 'Views/FreemiumEntry/HasRelationship/Content/Templates/PaymentPage/Content';
import { PromoCodeInputContextProvider } from 'Context/PromoCodeInputContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { LeadPropsContextProvider } from 'Context/LeadPropsContext';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import 'Components/Modals/PaymentModal/index.css';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { withPaymentPageDependencies } from 'Organisms/withPaymentPageDependencies';


const PaymentPage = withPaymentPageDependencies(() => {
  const { resource } = useMetaLayoutContext();
  const { rootNodeProps } = useEventTrackingLogEvent({ nodeName: 'eqfPaymentPage', isPageView: true });
  return (
    <QuizWrapperLayout>
      <div {...rootNodeProps} className="eqfPaymentPage">{/* Needed for the CSS for credit card inputs */}
        <StripeProvider apiKey={stripeNonSecretKey}>
          <Elements fonts={[{ family: 'Euclid Square', src: 'url(https://static.facetwealth.com/app/fonts/euclid-square-500-normal.otf)', weight: '500' }]}>
            <PromoCodeInputContextProvider>
              <LeadPropsContextProvider email={resource.attr('email')}>
                <PaymentPageContent />
              </LeadPropsContextProvider>
            </PromoCodeInputContextProvider>
          </Elements>
        </StripeProvider>
      </div>
    </QuizWrapperLayout>
  );
});

export { PaymentPage };
